var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "items color" }, [
    _c(
      "ul",
      {
        staticClass: "d-flex flex-wrap list-unstyled mb-0",
        attrs: { id: "colorList" },
        on: { mouseleave: _vm.resetPreviewImage },
      },
      _vm._l(_vm.variationsToShow, function (variation) {
        return _c(
          "li",
          {
            key: variation.variationId,
            on: {
              mouseenter: function ($event) {
                return _vm.previewImage(variation.previewImage)
              },
            },
          },
          [
            _c(
              "a",
              {
                class: {
                  sold: !variation.hasStock,
                  active: _vm.variationId === variation.variationId,
                },
                attrs: { href: _vm.langPrefix + variation.urlPath },
                on: { click: _vm.setShowAllState },
              },
              [
                _c("mh-item-image", {
                  attrs: {
                    "img-url": variation.previewImage,
                    alt: variation.name,
                    title:
                      variation.name +
                      (variation.hasStock
                        ? ""
                        : " - " +
                          _vm.$translate(
                            "modeherz::SingleItemPageClient.itemPageSoldOut"
                          )),
                    lazy: "",
                  },
                }),
              ],
              1
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    !_vm.opened && _vm.variationAttributes.length > _vm.preloadImageLimit
      ? _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            on: { click: _vm.showMore },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$translate(
                    "modeherz::SingleItemPageClient.itemPageShowMore"
                  )
                ) +
                "\n    "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }